import path from 'path';

const STATIC_ROOT = '/booking/assets';
var host = process.env.HOSTNAME || 'localhost';

export default {
    static: {
        path: path.resolve(process.cwd(), 'build/assets'),
        url: `http://${host}:3001/assets/`,
        root: STATIC_ROOT,
    },
    scripts: [
        '//cdnjs.cloudflare.com/ajax/libs/dom4/1.8.3/dom4.js',
        '//yastatic.net/jquery/2.1.3/jquery.js',
        `${STATIC_ROOT}/bootstrap/bootstrap.min.js`,
    ],
    styles: [
    	'//fonts.googleapis.com/css?family=Roboto:400,700&subset=cyrillic,latin,latin-ext',
        '//fonts.googleapis.com/css?family=Roboto+Slab:400,300&subset=latin,cyrillic',
        `${STATIC_ROOT}/spinner/spinner.min.css`,
        `${STATIC_ROOT}/bootstrap/bootstrap.min.css`
    ]
};



// WEBPACK FOOTER //
// ./configs/development/application.config.js